import { AgentsFactoryActionTypes } from './agentsFactory.types';

const signupRequest = () => ({ type: AgentsFactoryActionTypes.AGENTS_FACTORY_SIGNUP_REQUEST });
const signupSuccess = agentAuth => ({ type: AgentsFactoryActionTypes.AGENTS_FACTORY_SIGNUP_SUCCESS, payload: agentAuth });
const signupFailure = error => ({ type: AgentsFactoryActionTypes.AGENTS_FACTORY_SIGNUP_FAILURE, payload: error });

const createRequest = (payload, onSuccess) => ({
  type: AgentsFactoryActionTypes.AGENTS_FACTORY_CREATE_REQUEST,
  payload,
  onSuccess,
});
const createSuccess = agentData => ({ type: AgentsFactoryActionTypes.AGENTS_FACTORY_CREATE_SUCCESS, payload: agentData });
const createFailure = error => ({ type: AgentsFactoryActionTypes.AGENTS_FACTORY_CREATE_FAILURE, payload: error });

const changeStatusRequest = status => ({ type: AgentsFactoryActionTypes.AGENTS_FACTORY_CHANGE_STATUS_REQUEST, payload: status });
const changeStatusSuccess = agentData => ({ type: AgentsFactoryActionTypes.AGENTS_FACTORY_CHANGE_STATUS_SUCCESS, payload: agentData });
const changeStatusFailure = error => ({ type: AgentsFactoryActionTypes.AGENTS_FACTORY_CHANGE_STATUS_FAILURE, payload: error });

const requestImproveTextWithAI = prompt => ({
  type: AgentsFactoryActionTypes.AGENTS_FACTORY_IMPROVE_TEXT_WITH_AI_REQUEST,
  payload: prompt,
});
const successImproveTextWithAI = () => ({ type: AgentsFactoryActionTypes.AGENTS_FACTORY_IMPROVE_TEXT_WITH_AI_SUCCESS });
const failureImproveTextWithAI = () => ({ type: AgentsFactoryActionTypes.AGENTS_FACTORY_IMPROVE_TEXT_WITH_AI_FAILURE });
const setImprovedText = improvedText => ({ type: AgentsFactoryActionTypes.AGENTS_FACTORY_SET_IMPROVED_TEXT, payload: improvedText });
const loadingImproveTextWithAI = isLoading => ({ type: AgentsFactoryActionTypes.AGENTS_FACTORY_IMPROVE_TEXT_WITH_AI_LOADING, payload: isLoading });

const createDatabaseRequest = (payload, onSuccess) => ({
  type: AgentsFactoryActionTypes.AGENTS_FACTORY_CREATE_DATABASE_REQUEST,
  payload,
  onSuccess,
});
const createDatabaseSuccess = data => ({ type: AgentsFactoryActionTypes.AGENTS_FACTORY_CREATE_DATABASE_SUCCESS, payload: data });
const createDatabaseFailure = error => ({ type: AgentsFactoryActionTypes.AGENTS_FACTORY_CREATE_DATABASE_FAILURE, payload: error });

const actions = {
  signup: {
    request: signupRequest,
    success: signupSuccess,
    failure: signupFailure,
  },
  create: {
    request: createRequest,
    success: createSuccess,
    failure: createFailure,
  },
  changeStatus: {
    request: changeStatusRequest,
    success: changeStatusSuccess,
    failure: changeStatusFailure,
  },
  improveTextWithAI: {
    request: requestImproveTextWithAI,
    success: successImproveTextWithAI,
    failure: failureImproveTextWithAI,
    setImprovedText,
    loading: loadingImproveTextWithAI,
  },
  createDatabase: {
    request: createDatabaseRequest,
    success: createDatabaseSuccess,
    failure: createDatabaseFailure,
  },
};

export default actions;
